var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('section',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("\n      Changelog\n    ")]),_vm._v(" "),_vm._l((_vm.changelog.versions),function(version){return _c('version',{key:version.date,attrs:{"version":version}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745cb02d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/changelog/Changelog.vue
// module id = null
// module chunks = 